import _ from 'lodash';

import PLAYER from 'types/player';

import API from 'types/api';

const initialState = {
  video_id: null,
  stream: null,
  streamExternal: null,
  streamError: null,
  drmError: false,
  playbackError: false,
  videoInstances: [],
  isSeeking: false,
  isLoading: undefined,
  property: {
    quality: -1,
    started: false,
    duration: 0,
    position: 0,
    muted: false,
    volume: 60,
    paused: false,
    isBuffering: false,
    audioTrack: null,
    ended: false,
    qualityList: [],
    audioTrackList: [],
    subtitlesList: [],
    livePosition: 0,
    liveDuration: 0,
    liveTime: 0,
    liveIsTimeshift: false,
    state: 0,
    programPosition: 0,
    programDuration: 0,
    playingProgram: null,
    channelState: null,
    currentProgramTime: 0,
    currentChannel: null,
    thumbnails: {
      height: 0,
      offset: 0,
      src: '',
      width: 0,
    },
    isPipModeOn: false,
    pipIsSupported: false,
  },
};

export default (state = initialState, { type, payload, request }) => {
  switch (type) {
    case PLAYER.HANDLE_DISPOSE:
      return initialState;
    case PLAYER.HANDLE_CHANGE_PROPERTIES_PACK:
      return payload.reduce(handlePlayerProperty, state);
    case PLAYER.HANDLE_CHANGE_PROPERTY:
      return handlePlayerProperty(state, payload);
    case PLAYER.HANDLE_PLAYER_COMPLETED: // END
      return {
        ...state,
        property: {
          ...state.property,
          state: payload.data,
          position: 0,
          ended: !state.property.currentChannel, // do not set ended if this is TV
        },
      };

    case PLAYER.HANDLE_INFO_EVENT:
      if (payload.name === 'info:drmNotSupported') {
        return {
          ...state,
          drmError: true,
        };
      }
      return {
        ...state,
      };
    case PLAYER.ERROR:
    case PLAYER.HANDLE_MEDIA_ERROR_EVENT:
      if (payload.data.fatal) {
        return {
          ...state,
          playbackError: true,
          error: payload.data,
        };
      }
      return {
        ...state,
      };
    case PLAYER.HANDLE_SEEKING:
      return {
        ...state,
        isSeeking: payload,
      };
    case PLAYER.HANDLE_LEAVE_PIP_ON_PAUSE:
      return {
        ...state,
        property: {
          ...state.property,
          paused: true,
        },
      };
    case API.GET_STREAM_EXTERNAL:
      return {
        ...state,
        streamExternal: null,
        property: {
          ...state.property,
          subtitlesTextChange: null,
        },
      };
    case API.GET_STREAM:
      return {
        ...state,
        video_id: payload.video_id,
        streamError: null,
        stream: null,
        isLoading: true,
        property: {
          ...initialState.property,
          muted: state.property.muted,
          volume: state.property.volume,
          currentChannel: state.property.currentChannel,
          programDuration: state.property.programDuration,
          playingProgram: state.property.playingProgram,
          channelState: state.property.channelState,
          isBuffering: true,
          ended: false,
        },
      };
    case API.GET_STREAM_EXTERNAL_SUCCESS:
      return {
        ...state,
        streamExternal: payload,
      };
    case API.GET_STREAM_SUCCESS:
      if (Number(state.video_id) !== Number(request.video_id)) {
        return { ...state, isLoading: false };
      }
      // payload.is_autoplay = false; // Для тестов автоплея
      return {
        ...state,
        streamError: null,
        stream: payload,
        isLoading: false,
      };
    case API.GET_STREAM_ERROR:
      return {
        ...state,
        streamError: payload,
        stream: null,
        isLoading: false,
      };
    default:
      return state;
  }
};

function handlePlayerProperty(state, payload) {
  const propertyName = _.drop(payload.name.split(':')).join(':');
  let property = {};
  switch (propertyName) {
    case 'videoInstances':
      return {
        ...state,
        videoInstances: payload.data,
      };
    case 'videoInfo':
      property = {
        ...state.property,
        muted: state.property.muted,
        volume: state.property.volume,
        isBuffering: state.property.isBuffering,
        ended: false,
        quality: -1,
      };
      break;
    case 'muted':
      property = setPlayerProperty('muted', payload.data);
      break;
    case 'volume':
      property = setPlayerProperty('volume', payload.data);
      break;
    case 'qualityList':
      property = setPlayerProperty('qualityList', payload.data);
      break;
    case 'quality':
      property = setPlayerProperty('quality', payload.data);
      break;
    case 'audioTrackList':
      property = setPlayerProperty('audioTrackList', payload.data);
      break;
    case 'thumbnails':
      property = setPlayerProperty('thumbnails', payload.data);
      break;
    case 'sizeInfo':
      property = setPlayerProperty('sizeInfo', payload.data);
      break;
    case 'position':
      if (payload.data !== 0) {
        property = setPlayerProperty('position', payload.data);
      } else {
        property = setPlayerProperty('position', state.property.position);
      }
      break;
    case 'liveDvr:position':
      property = setPlayerProperty('livePosition', payload.data);
      break;
    case 'liveDvr:duration':
      property = setPlayerProperty('liveDuration', payload.data);
      break;
    case 'liveDvr:time':
      property = setPlayerProperty('liveTime', payload.data);
      break;
    case 'liveDvr:isTimeshift':
      property = setPlayerProperty('liveIsTimeshift', payload.data);
      break;
    case 'interactiveChannel:channelState':
      property = setPlayerProperty('channelState', payload.data);
      break;
    case 'interactiveChannel:currentPlayingProgram':
      property = setPlayerProperty('playingProgram', payload.data);
      break;
    case 'interactiveChannel:currentProgramDuration':
      property = setPlayerProperty('programDuration', payload.data);
      break;
    case 'interactiveChannel:currentPlayingTime':
      property = setPlayerProperty('programPosition', payload.data);
      break;
    case 'epg:currentProgramTime':
      property = setPlayerProperty('currentProgramTime', payload.data);
      break;
    case 'epg:currentChannel':
      property = setPlayerProperty('currentChannel', payload.data);
      break;
    case 'epg:currentTimestamp':
      property = setPlayerProperty('currentTimestamp', payload.data);
      break;
    case 'pip:pipIsSupported':
      property = {
        ...state.property,
        pipIsSupported: payload.data,
      };
      break;
    case 'pip:isPipModeOn':
      property = {
        ...state.property,
        isPipModeOn: payload.data,
      };
      break;
    case 'state':
      switch (payload.data) {
        case 1: // PLAYING
          // console.log('PLAYING', payload.data);
          property = {
            ...state.property,
            state: payload.data,
            paused: false,
            isBuffering: false,
            started: true,
            ended: false,
          };
          break;
        case 2: // PAUSE
          // console.log('PAUSE', payload.data);
          property = {
            ...state.property,
            state: payload.data,
            paused: true,
            isBuffering: false,
          };
          break;
        case 3: // BUFFER
          // console.log('BUFFER', payload.data);
          property = {
            ...state.property,
            state: payload.data,
            isBuffering: true,
          };
          break;
        case 4: // SEEK
          // console.log('SEEK', payload.data);
          property = {
            ...state.property,
            state: payload.data,
            isBuffering: true,
          };
          break;
        case 5: // WAITING (some middle state)
          // console.log('WAITING', payload.data);
          property = {
            ...state.property,
            state: payload.data,
            isBuffering: false,
            ended: false,
          };
          break;
        default:
          property = { ...state.property };
          break;
      }
      break;
    default:
      property = setPlayerProperty(propertyName, payload.data);
      break;
  }
  return {
    ...state,
    property,
  };

  function setPlayerProperty(key, value) {
    return {
      ...state.property,
      [key]: value,
    };
  }
}
